import {Logo, Partner} from '../../components';
import styles from './Header.module.scss';
import {useMediaQuery} from "react-responsive";

export const Header = () => {
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

    return (
        <header className={styles.header} id="header">
            <Logo color={isMobile ? 'dark' : 'white'} className={styles.logo} />
            <Partner color={isMobile ? 'green' : 'white'}/>
        </header>
    );
};
